import { createAgnosticHttpClient } from 'auth/infra/createAgnosticHttpClient'

import { ShipmentRepository } from '../infra/ShipmentRepository'

export type DownloadRateconFactoryDependencies = {
  repository: ShipmentRepository
}

export function downloadRateconFactory({ repository }: DownloadRateconFactoryDependencies) {
  return async function download(uuid: string, config?: { signal?: AbortSignal }) {
    try {
      return await repository.downloadRatecon(uuid, config)
    } catch (error) {
      throw new Error('Failed to download Ratecon', { cause: error as Error })
    }
  }
}

export function downloadRatecon(id: string, config?: { signal: AbortSignal }) {
  const httpClient = createAgnosticHttpClient()
  const repository = new ShipmentRepository({ httpClient })
  const download = downloadRateconFactory({ repository })

  return download(id, config)
}
